module.exports = require("@mui/icons-material/ContentCopy");